import { jsx as _jsx } from "react/jsx-runtime";
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { TonConnectUIProvider } from '@tonconnect/ui-react';
import { App } from './App';
import './index.css';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(_jsx(TonConnectUIProvider, { manifestUrl: "https://gist.github.com/anovic123/f58b49fdb4069da5412923ad9e6f4e7e.txt", children: _jsx(BrowserRouter, { children: _jsx(App, {}) }) }));
